import ObtainPersonalAPIKey from "../../../../contents/docs/integrate/_snippets/obtain-personal-api-key.mdx";
import * as React from 'react';
export default {
  ObtainPersonalAPIKey,
  React
};